import * as React from 'react';

export const Trapeze = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		fill="fillColor"
		viewBox="0 0 668 860"
		preserveAspectRatio="xMaxYMid slice"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M454 -30H698V873H0L454 -30Z" fill="fillColor" />
	</svg>
);
